/*eslint max-lines-per-function: ["error", 100]*/
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import type {
  GridGetterFunction,
  GridCountFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import { GetPaymentCollectionDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import momencik from '../../../common/momencik';
import mathUtils from '../../../utils/mathUtils';
import numberFormatter from '../../../common/numberFormatter';
import { InvoicePaymentsSearch } from '../../components/InvoicePayment/InvoicePaymentsSearch';

type ParamTypes = {
  collectionId: string;
};

export const PaymentCollectionPaymentsView: React.FC = () => {
  const { collectionId } = useParams<ParamTypes>();
  const spd = useSpdCore();
  const nav = useNavigation();
  const [collection, setCollection] = useState<
    GetPaymentCollectionDto | undefined
  >(undefined);

  useEffect(() => {
    if (collectionId) {
      spd.paymentCollections
        .getById(collectionId)
        .then(setCollection)
        .catch(console.error);
    }
  }, [collectionId, spd.paymentCollections]);

  const getData: GridGetterFunction = useCallback(
    (
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    ) =>
      spd.invoicePayments.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        collectionId,
      ),
    [collectionId, spd.invoicePayments],
  );

  const getCount: GridCountFunction = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.invoicePayments.getAllCount(filterText, filterColumns, collectionId),
    [collectionId, spd.invoicePayments],
  );

  const headerTitle = collection
    ? `Wpłaty zarejestrowane w zbiorze: ${collection.name || '—'}  (${momencik(collection.collectionDate, 'YYYY-MM-DD')})  —  suma: ${numberFormatter(collection.totalAmount ? mathUtils.parse(collection.totalAmount) : null, true) || '0,00 zł'}`
    : 'Wpłaty zarejestrowane w zbiorze';

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <span>{headerTitle}</span>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => nav.paymentCollections()}
        >
          ← Powrót do zbiorów
        </Button>
      </Card.Header>
      <Card.Body>
        <InvoicePaymentsSearch
          getData={getData}
          getCount={getCount}
          showFilter={true}
          withFilterInColumns={true}
          onRowClick={(id: string) => nav.invoicePaymentEditor(id)}
          showExport={true}
        />
      </Card.Body>
    </Card>
  );
};
